import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlagIcon from "vue-flag-icon";
import axios from "axios";
import store from "./store";
import i18n from "@/plugins/i18n";
import Swal from "sweetalert2";
import VueCookies from "vue-cookies";
import VueZxingScanner from "vue-zxing-scanner";
import Carousel3d from "vue-carousel-3d";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import "@/assets/styles/sweetalert-theme.css";
import "@/assets/styles/active-status-control.css";
import { applyAdminRequestTimeout, describeAdminTimeout } from "@/utils/adminRequestTimeout";
import enurl from "@/api/environment";
import { getSessionToken, isPadSession, renewPadSession } from "@/utils/padSession";
dayjs.extend(isBetween);

Vue.prototype.$http = axios;
axios.defaults.headers.common["Content-Type"] = "application/json";
Vue.use(VueCookies);

const token = Vue.$cookies.get("Token") || localStorage.getItem("Token");
const cookieLoginState = Vue.$cookies.get("isLoggedIn");
const isLoggedIn =
  localStorage.getItem("isLoggedIn") === "true" ||
  cookieLoginState === true ||
  cookieLoginState === "true";
if (token && isLoggedIn) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let isTokenAlertShown = false;
axios.interceptors.request.use(async (config) => {
  applyAdminRequestTimeout(config, router.currentRoute.name);
  const isAppRequest = config.url?.startsWith(enurl.apiUrl);
  const isLoginRequest = config.url?.startsWith(`${enurl.apiUrl}Login/`);
  if (isAppRequest && !isLoginRequest && isPadSession()) {
    try {
      if (store.state.status === "expired") {
        const error = new Error("Pad session expired");
        error.isSessionExpired = true;
        throw error;
      }
      const padToken = await renewPadSession();
      store.commit("auth_success", padToken);
      config.headers.Authorization = `Bearer ${padToken}`;
    } catch (error) {
      if (error.isSessionExpired) await handleTokenExpired(error.message);
      throw error;
    }
  }
  if (isAppRequest) config.sessionToken = getSessionToken();
  return config;
});
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    describeAdminTimeout(error, i18n.locale);
    const status = error?.response?.status;
    const isAppRequest = error.config?.url?.startsWith(enurl.apiUrl);
    const isLoginRequest = error.config?.url?.startsWith(`${enurl.apiUrl}Login/`);
    const isCurrentSession = error.config?.sessionToken === getSessionToken();
    if (status === 401 && isAppRequest && !isLoginRequest) {
      error.isSessionExpired = true;
    }
    if (status === 401 && isAppRequest && !isLoginRequest && isCurrentSession) {
      handleTokenExpired("Session ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่");
    }
    return Promise.reject(error);
  },
);

async function handleTokenExpired(message) {
  if (isPadSession()) {
    if (store.state.status !== "expired") await store.dispatch("ForceLogout", message);
    return;
  }
  if (isTokenAlertShown) return;
  isTokenAlertShown = true;

  try {
    document
      .querySelectorAll(
        ".v-dialog__content--active, .v-overlay, .v-overlay__scrim",
      )
      .forEach((el) => el.remove());
    document.body.classList.remove("overflow-y-hidden");

    store.commit("logout");
    Vue.$cookies.keys().forEach((k) => Vue.$cookies.remove(k));
    localStorage.removeItem("Token");
    localStorage.removeItem("isLoggedIn");
    delete axios.defaults.headers.common["Authorization"];

    await Swal.fire({
      title: "Session Expired",
      text: message,
      icon: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "ตกลง",
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: true,
    });

    const currentPath = router.currentRoute?.path || window.location.pathname;
    if (currentPath !== "/Login") {
      router.replace("/Login").catch(() => (window.location.href = "/Login"));
    }
  } catch (err) {
    window.location.href = "/Login";
  } finally {
    setTimeout(() => {
      isTokenAlertShown = false;
    }, 5000);
  }
}

window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false;
Vue.use(FlagIcon);
Vue.use(VueZxingScanner);
Vue.use(Carousel3d);
new Vue({
  i18n,
  vuetify,
  store,
  router,
  Swal,
  render: (h) => h(App),
}).$mount("#app");
